import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("mask", {
  id: "mask0_15381_14140",
  style: {"mask-type":"alpha"},
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "14",
  height: "14"
}, [
  /*#__PURE__*/_createVNode("rect", {
    width: "14",
    height: "14",
    fill: "#D9D9D9"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("g", { mask: "url(#mask0_15381_14140)" }, [
  /*#__PURE__*/_createVNode("path", {
    d: "M1.74772 12.2499V11.0832H12.2477V12.2499H1.74772ZM2.76855 9.33319L0.581055 5.68735L1.98105 5.30819L3.61439 6.67902L5.65605 6.13944L2.6373 2.11444L4.32897 1.66235L8.68939 5.32277L11.1686 4.65194C11.4797 4.56444 11.7738 4.6009 12.0508 4.76131C12.3279 4.92173 12.5102 5.15749 12.5977 5.4686C12.6852 5.77971 12.6488 6.07381 12.4883 6.3509C12.3279 6.62798 12.0922 6.81027 11.7811 6.89777L2.76855 9.33319Z",
    fill: "currentColor"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}